var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-select', _vm._b({
    attrs: {
      "items": _vm.categories,
      "item-text": "name",
      "item-value": "_id"
    },
    model: {
      value: _vm.$data._category,
      callback: function callback($$v) {
        _vm.$set(_vm.$data, "_category", $$v);
      },
      expression: "$data._category"
    }
  }, 'v-select', _vm.$attrs, false));
}
var staticRenderFns = []

export { render, staticRenderFns }